module.exports = __webpack_public_path__ + "static/media/selected_user.e3c400f3.svg";